<script lang="ts">
    import Container from "../containers/Container.svelte";
    import StepCard from "../elements/StepCard.svelte";
    import CTA from "../elements/CTA.svelte";

    type Steps = {
        heading: string;
        description: string;
        image: string;
    }[]

    export let title : string;
    export let steps : Steps;

</script>
    <div class="steps">
        <h2>{@html title}</h2>
        <div class="steps__items">
            {#each steps as step}
                <StepCard
                    heading={step.heading}
                    description={step.description}
                    webpUrl="/assets/{step.image}.webp"
                    pngUrl="/assets/{step.image}.png"
                    imageAlt="Step One"
                />
            {/each}
        </div>
        <div class="steps__cta">
            <CTA text="Get access to developers" url="https://www.offerzen.com/hire/get-started"/>
            <CTA text="Book a demo" url="https://www.offerzen.com/hire/book-call" theme="outlined-blue"/>
        </div>
    </div>
<style lang="postcss">

    @import '../../styles/_mixins.css';
    .steps {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        width:100%;
        align-items: center;
        position: relative;
        max-width:1200px;

        @mixin screen-sm {
            max-width:480px;
        }

        & h2 {
            color:var(--color_white);
            @mixin heading-h2;
            text-align:center;
            margin:0px 0 80px;

            @mixin screen-sm {
                text-align:left;
                margin: 0 0 40px;
            }

            & :global(span) {
                color: var(--color_offerzen_cerulean);
            }

        }

        & .steps__items {
            display: flex;
            flex-direction: row;
            gap:60px;
            align-items: center;
            justify-content: center;

            @mixin screen-lg {
                gap:55px;
            }

            @mixin screen-md {
                gap:0 40px;
                flex-wrap:wrap;
            }

            @mixin screen-sm {
                align-items:flex-start;
                justify-content:flex-start;
                flex-direction:column;
            }
        }

        & .steps__cta {
            display:flex;
            gap:24px;

            @mixin screen-sm {
                flex-direction:column;
                width:100%;
            }
        }
    }
</style>